<template>
  <div
    class="py-8 px-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7 lg:mx-8 mb-8"
  >
    <!-- <div class="text-center">
      <h1><b>Play&Go Aziende</b></h1>
    </div> -->
    <div class="m-8">
      <img
        src="@/assets/images/pgaziendale-black.png"
        alt="Aziende Play & Go"
        class="object-contain h-48 w-auto max-w-32 lg:m-auto ml-auto mr-1"
      />
    </div>
    <p>
      Il settore dei trasporti è quello che contribuisce di più alle emissioni di gas a
      effetto serra (GHG). Nel 2017, il 27% delle emissioni totali dell’ EU-28 GHG e’
      stato prodotto da questo settore. In questo ambito le città sono le principali
      sorgenti di richiesta di mobilità globale a causa delle attività di trasporto dei
      cittadini all’interno e tra le aree urbane.
    </p>
    <br />
    <p>
      Il traffico e le inefficienze del pendolarismo hanno un impatto negativo sulle
      infrastrutture urbane, aumentano l'inquinamento, danneggiano l'ambiente e la salute
      delle persone. Per affrontare e mitigare il traffico generato dai pendolari è
      necessario coinvolgere gli stakeholder pubblici e privati attraverso un nuovo
      approccio innovativo e collaborativo in grado di concentrarsi non solo sull'offerta
      (ad esempio, strade e veicoli), ma anche sulla gestione della domanda di trasporto.
    </p>
    <br />
    <p>
      Negli ultimi anni, le autorità pubbliche hanno allargato la loro attenzione dalle
      politiche di gestione della domanda che si rivolgono agli individui e alle famiglie
      (che sono un obiettivo politico ampiamente eterogeneo e disaggregato) alle politiche
      di gestione della domanda che si rivolgono ai grandi generatori di traffico -
      compresi i settori pubblico e privato.
    </p>
    <br />
    <p>
      Ora, il COVID-19 sta generando un rapido cambiamento nel modo in cui le persone
      lavorano, agiscono e si muovono, che potrebbe aprire la strada a un maggiore
      cambiamento nel comportamento dei trasporti. Ciò significa che sarà necessario un
      duro lavoro per plasmare i nuovi comportamenti che si formeranno in futuro.
    </p>
    <br />
    <p>
      Per questo motivo, il progetto <b>Play&Go Aziende </b> promuove un approccio al
      trasporto e alla mobilità orientato ai lavoratori in grado di supportare il Mobility
      Manager aziendale agendo sulla promozione della mobilità sostenibile e gestione
      della domanda di trasporto analizzando i problemi, le necessità e le abitudini dei
      lavoratori, le misure Covid-19 adottate dalle aziende, cercando di orientarli verso
      nuove abitudini di trasporto sostenibile;
    </p>
    <br />
    <p>
      <b>Play&Go Aziende</b> intende proporre un approccio socio-tecnico in grado di
      coniugare strumenti tecnologici, metodologie di progettazione collaborativa, accesso
      a dati e informazioni, incentivi e azioni e iniziative integrative di informazione,
      promozione e apprendimento basate anche sulla gamification.
    </p>
    <br />
    <p>
      <b>Play&Go Aziende</b>, facendo leva sul cambiamento comportamentale, sulle
      tecnologie e sul modello di business, intende agire sui fattori risolutivi che
      ostacolano il trasferimento modale fornendo servizi, informazioni, raccomandazioni e
      incentivi al fine di:
    </p>
    <ul class="list-disc space-y-2">
      <li class="flex items-start">
        <span class="h-6 flex items-center sm:h-7">
          <svg
            class="flex-shrink-0 h-5 w-5 text-cyan-500"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clip-rule="evenodd"
            />
          </svg>
        </span>
        <p class="ml-2">
          supportare le Aziende nell'adozione di politiche e iniziative per pianificare e
          attuare azioni e misure per individuare la soluzione di mobilità più
          sostenibile.
        </p>
      </li>
      <li class="flex items-start">
        <span class="h-6 flex items-center sm:h-7">
          <svg
            class="flex-shrink-0 h-5 w-5 text-cyan-500"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clip-rule="evenodd"
            />
          </svg>
        </span>
        <p class="ml-2">
          incoraggiare i lavoratori a cambiare significativamente i loro modelli di
          mobilità, rendendoli parte attiva della soluzione.
        </p>
      </li>
    </ul>
    <p>
      Trasformare positivamente il modo di viaggiare delle persone a beneficio della
      società richiede una profonda trasformazione delle abitudini e dei comportamenti dei
      lavoratori, che deve essere basata su valutazioni e simulazioni di impatto complete,
      che tengano conto degli impatti sociali, sanitari, ambientali e climatici, nonché
      dell'impatto economico.
    </p>
    <br />
    <p>
      <b>Play&Go Aziende</b> vuole impegnarsi in una nuova soluzione innovativa che
      fornisca una console di dati, informazioni, raccomandazioni e simulazioni per i
      Mobility Manager che permettono di valutare, anche attraverso analisi what-if,
      l'impatto ambientale del pendolarismo dei dipendenti, di valutare i cambiamenti a
      seguito di misure e azioni specifiche e di pianificare strategie di mobilità dei
      lavoratori ottimali e sostenibili.
    </p>
    <p>
      <b>Play&Go Aziende</b> e’ stato realizzato da
      <b>Fondazione Bruno Kessler (FBK)</b> nel contesto del progetto
      <b>UIA Air-Break.</b>
    </p>
  </div>
</template>

<script>
export default {
  name: "Info",
  created() {
    this.$store.dispatch("storePage", { title: "Info", back: false });
  },
};
</script>

<style></style>
